export const MAX_ATTACHED = {
  MULTIMEDIA: 10,
  FILES: 4,
};

export const MAX_HEIGHTS = {
  VIDEO: 300,
  IMAGE: 350,
};

export const MAX_HEIGHTS_POSTS = {
  VIDEO: 620,
  IMAGE: 620,
};

export const MAX_HEIGHTS_PREVIEW = {
  VIDEO: 760,
  IMAGE: 760,
};

export const PLAYBACKRATE = {
  NORMAL: 1,
  ONE_AND_HALF_SPEED: 1.5,
  DOUBLE_SPEED: 2,
};

export const SIGNS = {
  DOT: '.',
  QUESTION_MARK: '?',
};

export const IMAGE_COMPRESSION_QUALITY = 0.5;
export const IMAGE_CONVERT_TYPES = ['image/png', 'image/webp'];
export const IMAGE_CONVERT_SIZE = 500000;
